import {
    withHeaders,
    instance as axiosInstance,
} from '../core/util/axiosInstance';
import { getDefaultHeaders, useAlert } from '../core';
import { MutationFunction, UseMutationResult, useMutation } from 'react-query';
import { AxiosResponse } from 'axios';
import { commonShowAlert } from '../lib';
import { FILE_UPLOAD_SUCCESS_MSG } from '../pages/job-manager/job-manager-helper';

interface PostExportDataJobProps {
    token: string;
    chain: string;
    password?: string;
}

export const postExportDataJob: MutationFunction<
    AxiosResponse<any>,
    PostExportDataJobProps
> = async (props: PostExportDataJobProps) => {
    const { token, password, chain } = props;
    const headers = getDefaultHeaders(token);
    const dropChainJobUrl = `/jobs/${chain}/export`;

    return axiosInstance().post(
        dropChainJobUrl,
        { password, chain },
        withHeaders(headers)
    );
};

export const useExportDataJob = (): UseMutationResult<
    AxiosResponse<any>,
    unknown,
    PostExportDataJobProps
> => {
    const { showAlert, hideAlert, showErrorDetails } = useAlert();

    return useMutation(postExportDataJob, {
        onSuccess: () => {
            commonShowAlert(
                showAlert,
                hideAlert,
                'success',
                FILE_UPLOAD_SUCCESS_MSG
            );
        },
        onError: (error: any) => {
            const errorMessage: string =
                error?.data?.message ?? 'Unable to export data job';
            commonShowAlert(
                showAlert,
                hideAlert,
                'error',
                errorMessage,
                JSON.stringify(error?.data ?? ''),
                showErrorDetails
            );
        },
    });
};
